import React from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import styles from './Wizard.module.css';

const WizardTabs = ({ availableTabs, selectedTab, setSelectedTab, tabButton, invalidTabs = [], dirtyTabs }) => {
    const tabsClasses = makeStyles({
        root: {
            borderBottom: '1px solid #ccc',
            minHeight: '40px'
        },
        indicator: {
            display: 'flex',
            backgroundColor: '#188ded',
            height: '1px'
        },
        invalidIndicator: {
            display: 'flex',
            backgroundColor: '#ff3c3c',
            height: '1px'
        }
    })();

    const tabClasses = makeStyles({
        root: {
            textTransform: 'none',
            fontSize: '18px',
            fontFamily: 'Saira',
            fontWeight: 500,
            minWidth: '120px',
            maxWidth: '300px',
            minHeight: '40px',
            letterSpacing: 'normal',
            padding: '0 10px'
        },
        selected: {
            fontWeight: 600
        }
    })();

    if (availableTabs.length === 0) {
        return tabButton;
    }
    const selectedTabInvalid = invalidTabs.includes(selectedTab.toString());

    return (
        <div className={`${tabButton ? styles.tabsRow : ''}`}>
            <Tabs
                value={selectedTab}
                onChange={(event, value) => {
                    setSelectedTab(value);
                }}
                classes={{
                    root: tabsClasses.root,
                    indicator: selectedTabInvalid ? tabsClasses.invalidIndicator : tabsClasses.indicator
                }}
                variant="scrollable">
                {availableTabs.map((tab, index) => {
                    const invalid = invalidTabs.includes(index.toString());
                    const dirty = dirtyTabs.includes(index.toString());
                    return (
                        <Tab
                            id={`settings-wizard-tabs-${tab.toString().toLowerCase()}`}
                            label={
                                <div className={styles.tabLabel}>
                                    {tab && (
                                        <span className={`${styles.tabName} ${invalid ? styles.tabNameWithDot : ''}`}>
                                            {tab}
                                        </span>
                                    )}
                                    {invalid && <span className={styles.invalidDot}></span>}
                                    {!invalid && dirty && <span className={styles.unsavedDot}></span>}
                                </div>
                            }
                            classes={{ root: tabClasses.root, selected: tabClasses.selected }}
                            value={index}
                            key={`${tab}_${index}`}
                        />
                    );
                })}
            </Tabs>
            {tabButton}
        </div>
    );
};

export default React.memo(WizardTabs);
